import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "authConfig/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
